import { motion } from "framer-motion";
import { MP } from "@/data/news";
import { ShareRow } from "@/components/site/Share";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const shareUrlFor = (slug) => (slug ? `${BACKEND}/api/share/${slug}` : undefined);

export default function MPGrid({ items }) {
  const data = items && items.length ? items : MP;
  const lead = data.find((m) => m.lead) || data[0];
  const rest = data.filter((m) => m.id !== lead.id);

  return (
    <section
      id="mp"
      data-testid="mp-section"
      className="bg-[#EFEEE8] border-y border-[#0F0F0F]/20"
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
          <div>
            <div className="eyebrow text-[#D92525] mb-3">राज्य · मध्यप्रदेश</div>
            <h2 className="font-serif-dev font-black text-[38px] md:text-[52px] leading-[1.02]">
              प्रदेश की <span className="italic">धड़कन</span>
            </h2>
          </div>
          <a href="/category/mp" data-testid="mp-more" className="font-sans-dev text-[12px] tracking-[0.24em] uppercase link-underline">
            सारी प्रदेश ख़बरें →
          </a>
        </div>

        <div className="grid grid-cols-12 gap-6 md:gap-10">
          {/* Lead */}
          <motion.a
            href={lead.slug ? `/news/${lead.slug}` : "#"}
            data-testid={`mp-lead-${lead.id}`}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="col-span-12 lg:col-span-7 group block"
          >
            <div className="thumb-wrap aspect-[16/10] mb-6 border border-[#0F0F0F]/20">
              <img src={lead.img} alt={lead.title} className="w-full h-full object-contain" />
            </div>
            <div className="eyebrow text-[#D92525] mb-3">{lead.kicker} · {lead.time}</div>
            <h3 className="font-serif-dev font-black text-[28px] md:text-[38px] leading-[1.1] headline-link max-w-[640px]">
              {lead.title}
            </h3>
            <p className="mt-4 font-sans-dev text-[15px] md:text-[16px] text-[#4A4A4A] leading-relaxed max-w-[600px]">
              विपक्ष ने आरोप लगाया कि सरकार बहस से भाग रही है; सत्र के पहले ही दिन कई मुद्दों पर तीखी बहस के आसार हैं। सदन में हंगामे की संभावना।
            </p>
            <div className="mt-5">
              <ShareRow title={lead.title} url={shareUrlFor(lead.slug)} size="lg" testid={`share-mp-lead-${lead.id}`} />
            </div>
          </motion.a>

          {/* Right column list */}
          <div className="col-span-12 lg:col-span-5">
            <ul className="divide-y divide-[#0F0F0F]/15">
              {rest.map((m, i) => (
                <motion.li
                  key={m.id}
                  initial={{ opacity: 0, y: 16 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.5, delay: i * 0.08 }}
                  className="py-6 first:pt-0"
                >
                  <a href={m.slug ? `/news/${m.slug}` : "#"} data-testid={`mp-item-${m.id}`} className="grid grid-cols-12 gap-4 items-start group">
                    <div className="col-span-4 thumb-wrap aspect-[4/3] border border-[#0F0F0F]/15">
                      <img src={m.img} alt={m.title} className="w-full h-full object-contain" />
                    </div>
                    <div className="col-span-8">
                      <div className="eyebrow text-[#D92525] mb-1.5">{m.kicker} · {m.time}</div>
                      <h4 className="font-serif-dev font-bold text-[17px] md:text-[19px] leading-snug headline-link">
                        {m.title}
                      </h4>
                    </div>
                  </a>
                </motion.li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
